import React, { useContext, useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { LoadingContext } from "../App";
import { useNavigation } from "react-router-dom";
import { useSelector } from "react-redux";

const useLaader = () => {
	const navigation = useNavigation();
	const [loading, setLoading] = useState(false);
	let load = navigation?.state === "submitting" || navigation.state !== "idle";
	const [ids, setLoad] = useState([]);

	useEffect(() => {
		if (ids.length && !load && !loading) {
			return setLoad(ids.slice(1));
		}
	}, [ids, load, loading]);
	return { load, ids, setLoad, setLoading, loading };
};

const PageSpinner = () => {
	const { pageSpinner } = useContext(LoadingContext);
	const { load } = useLaader();
	const { pageSpinners: isPageLoading = [] } = useSelector(
		state => state.spinners,
	);
	return (pageSpinner && pageSpinner.length) || isPageLoading.length || load ? (
		<div className="spinner-background">
			<div className="spinner-block">
				<Spinner animation="border" variant="primary" />
			</div>
		</div>
	) : null;
};
export default PageSpinner;
